import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import get from 'lodash/get';
import CopyRightSection from './copyright-section';
import GetInTouch from './get-in-touch';
import {
  GET_REG_UPDATES_FOOTER_LINKS,
  NDTV_FOOTER_LINKS,
  FOOTER_QUICK_LINKS,
} from '../../../constants';
import './ndtv-footer.m.css';
import SiteMap from './sitemap';

const NdtvFooter = ({ pageType, userData }) => {
  const defaultSiteMap = {
    quickLinks: {
      header: FOOTER_QUICK_LINKS?.header,
      links: FOOTER_QUICK_LINKS?.links || [],
    },
    allSectionList: {
      header: NDTV_FOOTER_LINKS?.header,
      links: NDTV_FOOTER_LINKS?.links || [],
    },
    stayUpdateLinks: {
      header: GET_REG_UPDATES_FOOTER_LINKS?.header,
      links: GET_REG_UPDATES_FOOTER_LINKS?.links || [],
    },
  };
  const endpoint = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'ndtv-footer', 'api_endpoint'], null),
  );
  const [siteMapList, setSiteMapList] = useState(defaultSiteMap);

  useEffect(() => {
    let mounted = true;
    const fetchFooterData = async () => {
      try {
        const res = await fetch(endpoint);
        if (!res.ok) {
          return;
        }
        const json = await res.json();
        if (mounted) {
          const siteMapData = json?.data || json;
          const quickLinks = { header: FOOTER_QUICK_LINKS?.header, links: [] };
          const allSectionList = { header: NDTV_FOOTER_LINKS?.header, links: [] };
          const stayUpdateLinks = { header: GET_REG_UPDATES_FOOTER_LINKS?.header, links: [] };
          // Defensive iterate: data may be undefined/null
          (Array.isArray(siteMapData) ? siteMapData : []).forEach((item) => {
            if (item?.Desc?.toLowerCase() === FOOTER_QUICK_LINKS?.header?.toLowerCase()) {
              quickLinks.links.push(item);
            } else if (item?.Desc?.toLowerCase() === NDTV_FOOTER_LINKS?.header?.toLowerCase()) {
              allSectionList.links.push(item);
            } else {
              stayUpdateLinks.links.push(item);
            }
          });
          const formattedData = { quickLinks, allSectionList, stayUpdateLinks };
          setSiteMapList(formattedData);
        }
      } catch (err) {
        if (mounted) setSiteMapList(defaultSiteMap);
      }
    };

    fetchFooterData();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <footer styleName="ndtv-footer" id="footer">
      <div styleName="footer-container" className="container">
        <div styleName="map-section">
          <GetInTouch pageType={pageType} userData={userData} />
          <SiteMap pageType={pageType} userData={userData} siteMapList={siteMapList} />
        </div>

        <CopyRightSection pageType={pageType} userData={userData} />
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => {
  return {
    pageType: get(state, ['qt', 'pageType'], null),
    userData: get(state, ['userData'], null),
  };
};

export default connect(mapStateToProps, null)(NdtvFooter);
